module.exports = __webpack_public_path__ + "static/media/ccm-service.f51dbffa.png";